var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 2.65181C12.9 2.16197 12.4987 1.76788 12 1.76788C11.5012 1.76788 11.1 2.16197 11.1 2.65181V8.54467H5.09995C4.6012 8.54467 4.19995 8.93875 4.19995 9.4286C4.19995 9.91844 4.6012 10.3125 5.09995 10.3125H11.1V16.2054C11.1 16.6952 11.5012 17.0893 12 17.0893C12.4987 17.0893 12.9 16.6952 12.9 16.2054V10.3125H18.9C19.3987 10.3125 19.8 9.91844 19.8 9.4286C19.8 8.93875 19.3987 8.54467 18.9 8.54467H12.9V2.65181Z",
    fill: "#1D5AB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b230b85352cd0a65f92b81a51819c972.svg";
export { ForwardRef as ReactComponent };